export const FOOTER_TEXT = "Ask For Helping Hand is an independent assistance service, not a government agency.";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 px-6 py-3 text-xs text-slate-500 dark:border-slate-800">
      {FOOTER_TEXT}
    </footer>
  );
}
